"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleSignIn = void 0;
const react_native_config_1 = __importDefault(require("react-native-config"));
const Authentication_1 = __importDefault(require("./Authentication"));
const auth_1 = require("firebase/auth");
class GoogleSignIn {
    static SignIn() {
        let scopes = [
            encodeURIComponent('https://www.googleapis.com/auth/userinfo.email'),
            encodeURIComponent('https://www.googleapis.com/auth/userinfo.profile')
        ];
        globalThis.location.href = 'https://accounts.google.com/o/oauth2/v2/auth'
            + '?scope=' + scopes.join('+')
            + '&response_type=token'
            + '&state=none'
            + '&redirect_uri=' + encodeURIComponent(globalThis.location.origin + '/login')
            + '&client_id=' + react_native_config_1.default.GOOGLE_SIGNIN_CLIENTID;
        return new Promise(() => { });
    }
    static SignInWithPopup() {
        const provider = new auth_1.GoogleAuthProvider();
        provider.addScope('https://www.googleapis.com/auth/userinfo.email');
        provider.addScope('https://www.googleapis.com/auth/userinfo.profile');
        const auth = (0, auth_1.getAuth)();
        return (0, auth_1.signInWithPopup)(auth, provider);
    }
    static async Link() {
        const credential = await this.SignInWithPopup();
        Authentication_1.default.LinkWithGoogle(credential);
    }
    static Revoke(currentProvider) {
        return Authentication_1.default.RevokeWithGoogle(currentProvider);
    }
    static GetRedirectResult() {
        let token = GoogleSignIn.GetAccessToken();
        if (token)
            return Authentication_1.default.SignInWithGoogle(null, token);
        else
            return Promise.resolve();
    }
    static GetAccessToken() {
        let query = new URLSearchParams('?' + globalThis.window.location.hash.substring(2));
        let token = query.get('access_token');
        return token;
    }
    static HasProvider() {
        var auth = (0, auth_1.getAuth)();
        return auth?.currentUser?.providerData?.filter(userInfo => userInfo?.providerId === 'google.com')?.length > 0;
    }
}
exports.GoogleSignIn = GoogleSignIn;
